import { AdminsList} from "./AdminsList";

export default AdminsList;
